import room_lastmessage from "./room_lastmessage";
import room_user from "../../../shared_fca/room_user";

export default class room {
    roomId = 'allUsers';
    roomName = 'Town Group Chat';
    avatar = '';
    unreadCount = 0;
    index = 0;
    lastMessage: room_lastmessage | null = null;
    users: room_user[] = [];
    typingUsers: number[] = [];
}
